import { v as validateBodyMiddleware } from "../../../chunks/middleware.js";
import { b as userSignUpSchema } from "../../../chunks/validation.js";
import { error } from "@sveltejs/kit";
import { a as authServer } from "../../../chunks/auth-server.js";
import { c as cookieStrToObj } from "../../../chunks/utils2.js";
import { R as REGISTRATION_ALLOW_LIST, B as BETTER_AUTH_SESSION_COOKIE } from "../../../chunks/index3.js";
const ALLOW_LIST = new Set(REGISTRATION_ALLOW_LIST);
const actions = {
  async default(event) {
    const body = await validateBodyMiddleware(userSignUpSchema, event);
    if (body.password !== body.repeatPassword) {
      error(400, "Password does not match repeat password");
    }
    if (!ALLOW_LIST.has(body.email)) {
      error(400, "Thank you for your interest, but the email provided is not in the allow list.");
    }
    const authResponse = await authServer.api.signUpEmail({
      body,
      headers: event.request.headers,
      asResponse: true
    });
    const setCookieHeader = authResponse.headers.get("set-cookie") ?? "";
    const cookiesObj = cookieStrToObj(setCookieHeader);
    event.cookies.set(BETTER_AUTH_SESSION_COOKIE, cookiesObj[BETTER_AUTH_SESSION_COOKIE], {
      path: "/",
      ...cookiesObj
    });
    const data = await authResponse.json();
    return data;
  }
};
export {
  actions
};
